import { FC, useCallback, useEffect, useMemo, useState } from "react";
import Modal from "../Modal";
import classNames from "classnames";
import PieceTable from "./PieceTable";
import { getCode } from "country-list";
import LoadingIcon from "../LodingIcon";
import AnimatedHeight from "../AnimatedHeight";
import { useNavigate } from "react-router-dom";
import ShipmentItemTable from "./ShipmentItemTable";
import ShipmentTableCheck from "./ShipmentTableCheck";
import { XMarkIcon } from "@heroicons/react/20/solid";
import { getCode as getSpanishCode } from "country-list-spanish";
import { LinkText, PrimaryButton, SecondaryButton } from "../Buttons";
import { useAppDispatch, useAppSelector } from "../../store/hooks";
import {
  FileDocument,
  PrintPieceLabel,
  PrintShipmentLabel,
  ShipmentDeclaredDocumentRequestDto,
  addressValidation,
  alertService,
  convertPieceToDhlPackageDto,
  convertRatesDHLResponseToItemInterface,
  getAccount,
  getAllDeclaredShipmentDocuments,
  getAllShipmentContentInvoice,
  getAvailableCoupons,
  getDocument,
  getRatesDHL,
  getService,
  getShipment,
  getShipmentEstimatedDeliveryTime,
  getShipmentRates,
  getShipmentTracking,
  loaderService,
  redeemCoupon,
  updateShipment,
  updateShipmentStatus,
  verifyAccountBlackList,
} from "../../services";
import {
  ShipmentStatus,
  DocumentStatus,
  ShipmentInterface,
  PaymentMode,
  ShipmentTracking,
  ShipmentService,
  AccountInterface,
  BusinessUnitInterface,
  LocationInterface,
  DeliveryType,
  DocumentInterface,
  PaymentStatusEnum,
  BusinessType,
  PaymentMethodEnum,
} from "../../interfaces";
import {
  formatDate,
  paymentModeFormat,
  documentStatusFormat,
  shipmentStatusFormat,
  currencyExchangeText,
  useCurrencyExchanges,
} from "../../utils";
import {
  CheckCircleIcon,
  ChevronDownIcon,
  ExclamationTriangleIcon,
} from "@heroicons/react/24/outline";
import {
  PickupPhase,
  restartShipmentCreate,
  setPickupCoupon,
  setPickupDocument,
  setPickupOwner,
  setPickupPayments,
  setPickupPhase,
  setPickupShipments,
  setPickupTaxes,
} from "../../store/slices";
import { PickupModal } from "./PickupModal";
import DropdownMenu from "../DropdownMenu";
import moment from "moment-timezone";
import { CouponDTO } from "../../interfaces/Dtos/CouponDTO";
import { StoreShipmentInterface } from "../../interfaces/Dtos";
import { GoogleMap, MarkerF } from "@react-google-maps/api";
import OptionalShipmentItems from "./OptionalShipmentItems";
import { ServiceDTO } from "../../interfaces/Dtos/ServiceDTO";
import { searchLiabilityWaiver } from "../../services/liabilityWaiverServices";
import { getPODDocument } from "../../services/podServices";
import { OriginModal } from "./OriginModal";
import { DigitalDocsInterfaceRequest } from "../../interfaces/DigitalDocsInterface";
import {
  getDigitalDocsStatus,
  getLiabilityWaiverDigitalDoc,
  getPODDigitalDoc,
} from "../../services/digitalDocsServices";
import { SearchShipmentContentInvoiceDTO } from "../../interfaces/Dtos/SearchShipmentContentInvoiceDTO";
import DocumentCompatibleShipmentsModal from "./DocumentCompatibleShipmentsModal";
import { dhlAddressStringBuilder } from "../../utils/dhlAddressStringBuilder";
import { splitAddress } from "../../utils/splitAddress";
import WarningModal from "../WarningModal";
import { getEventTrackingList } from "../../services/trackingService";
import { EventTrackingDto } from "../../interfaces/Dtos/EventTrackingDTO";
import { IncidenceFormValues, NewIncidenceModal } from "./NewIncidenceModal";
import { FormTextInput } from "../FormFields";
import { addIncidence } from "../../services/incidenceService";

enum PrintOption {
  SHIPMENT,
  DOCUMENT,
  POD,
}
const originOptions = [
  { title: "Etiqueta", value: PrintOption.SHIPMENT },
  { title: "Documento Guía", value: PrintOption.DOCUMENT },
];

const destinationOptions = [
  { title: "Documento para POD", value: PrintOption.POD },
];

export interface ShipmentDetailsModalProps {
  shipmentNumber: string;
  openModal: boolean;
  shipment?: ShipmentInterface;
  shipments?: StoreShipmentInterface[];
  hideButtons?: boolean;
  onReload?: () => void;
  setOpenModal: React.Dispatch<React.SetStateAction<boolean>>;
}
const ShipmentDetailsModal: FC<ShipmentDetailsModalProps> = ({
  shipment,
  shipments,
  shipmentNumber,
  openModal,
  hideButtons,
  onReload = () => {},
  setOpenModal,
}) => {
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const user = useAppSelector((state) => state.user);
  const businessUnit = useAppSelector((state) => state.user.businessUnit);
  const businessUnits = useAppSelector(
    (state) => state.inmutable.businessUnits
  );
  const applicationID = useAppSelector(
    (state) => state.inmutable.appData.applicationID
  );
  const holidays = useAppSelector((state) => state.inmutable.holidays);

  const [refresh, setRefresh] = useState(0);
  const loading = loaderService.useIsLoading();
  const [details, setDetails] = useState(false);
  const [delivered, setDelivered] = useState(false);
  const [shipment_, setShipment] = useState(shipment);
  const [pickupMode, setPickupMode] = useState(false);
  const [service, setService] = useState<ServiceDTO>();
  const [openPopover, setOpenPopover] = useState(false);
  const [aproximated, setAproximated] = useState(false);
  const [openAnulation, setOpenAnnulation] = useState(false);
  const [deliveryDistance, setDeliveryDistance] = useState(0);
  const [pickupDistance, setPickupDistance] = useState(0);
  const [document_, setDocument] = useState<DocumentInterface>();
  const [openPickupModal, setOpenPickupModal] = useState(false);
  const [tracking, setTracking] = useState<ShipmentTracking[]>([]);
  const [showIncidenceForm, setShowIncidenceForm] = useState(false);
  const [openConfirmDelete, setOpenConfirmDelete] = useState(false);
  const [openOptionalItems, setOpenOptionalItems] = useState(false);
  const [estimatedDeliveryTime, setEstimatedDeliveryTime] = useState<number>();
  const [userLogin, setUserLogin] = useState(user.user?.userLogin ?? "");
  const [trackingList, setTrackingList] = useState<EventTrackingDto[]>([]);
  const [newShipmentSubtituteIncidence, setnewShipmentSubtituteIncidence] =
    useState<any>({});

  const [openSubstitutionIncidence, setOpenSubstitutionIncidenceModal] =
    useState(false);
  const [substitutionShipmentIncidence, setSubstitutionShipmentIncidence] =
    useState<string | null>(null);

  const [openDocumentCompatibleModal, setOpenDocumentCompatibleModal] =
    useState(false);
  const [isPhysicalLiability, setIsPhysicalLiability] = useState<
    boolean | null
  >(null);
  const [isPhysicalPOD, setIsPhysicalPOD] = useState<boolean | null>(null);
  const [openLiabilityWaiverModal, setOpenLiabilityWaiverModal] =
    useState(false);
  const [center, setCenter] = useState<google.maps.LatLngLiteral | undefined>(
    undefined
  );
  const [selectedShipmentNumbers, setSelectedShipmentNumbers] = useState<
    string[]
  >([]);
  const [liabilityShipments, setLiabilityShipments] = useState<string[]>([]);
  const [shipmentContentInvoices, setShipmentContentInvoices] = useState<
    SearchShipmentContentInvoiceDTO[]
  >([]);
  const [openPOPWarningModal, setOpenPOPWarningModal] = useState(false);
  const exchanges = useCurrencyExchanges(
    !!shipment_?.document ? shipment_?.document.creationDate : undefined
  );

  const isModifiable = useMemo(() => {
    return (
      !!shipment_ &&
      (shipment_.status === ShipmentStatus.ACTIVE ||
        shipment_.status === ShipmentStatus.DRAFT) &&
      !shipment_.document &&
      shipment_.buSource?.code === user?.businessUnit?.code &&
      shipment_.lastBU === user?.businessUnit?.code &&
      moment(shipment_.createdAt).isSame(shipment_.lastBUDate, "day") &&
      !shipment_.deliveryCreationUser
    );
  }, [shipment_, user]);

  const ipostel = useMemo(() => {
    return shipment_?.totalPostalTaxBaseCurr === 0 ||
      shipment_?.totalPostalTaxBaseCurr === undefined
      ? shipment_?.items.reduce((acc, item) => acc + item.rate.ipostel, 0)
      : shipment_?.totalPostalTaxBaseCurr;
  }, [shipment_?.items, shipment_?.totalPostalTaxBaseCurr]);

  const totalWithTaxes = useMemo(() => {
    return (
      (shipment_?.total ?? 0) +
      (shipment_?.items.reduce((acc, item) => acc + item.rate.iva, 0) ?? 0) +
      (ipostel ?? 0)
    );
  }, [shipment_, ipostel]);

  const isPaid = useMemo(() => {
    return (
      !!document_ &&
      (document_.status === DocumentStatus.PAID ||
        document_.balanceAmount -
          document_.payments
            .filter((p) => p.status === PaymentStatusEnum.PENDING)
            .reduce((acc, p) => acc + p.amount, 0) <=
          0.01)
    );
  }, [document_]);

  const isPrintable = useMemo(() => {
    const userBUCode = user?.businessUnit?.code;

    return (
      // The shipment isn't null
      !!shipment_ &&
      // The shipment is a substitute or the user's business unit is the same
      // as the shipment's source business unit
      (!!shipment_.substituteFor || shipment_.buSource?.code === userBUCode) &&
      // The shipment's last business unit is the user business unit
      shipment_.lastBU === userBUCode &&
      // If the shipment is Contado, then
      (shipment_.paymentMode !== PaymentMode.CONTADO ||
        // The shipment is paid
        isPaid) &&
      // If the shipment is Source Box Office Credit, then
      (shipment_.paymentMode !== PaymentMode.BOXOFFICE_CREDIT ||
        // The shipment has an invoice
        !!document_) &&
      // The shipment is active or is credit
      (shipment_.status === ShipmentStatus.ACTIVE ||
        shipment_.paymentMode === PaymentMode.CREDIT)
    );
  }, [shipment_, user, isPaid, document_]);

  const isDeliverable = useMemo(() => {
    return (
      !!shipment_ &&
      shipment_.status === ShipmentStatus.ACTIVE &&
      shipment_.buConsignee?.code === user?.businessUnit?.code &&
      shipment_.lastBU === user?.businessUnit?.code &&
      (shipment_.paymentMode !== PaymentMode.CONTADO || isPaid) &&
      ((shipment_?.items.find((item) => item.isItemBase)?.rate.value ?? 0) >
        0 ||
        isPaid ||
        shipment_?.paymentMode === PaymentMode.CREDIT ||
        shipment_?.paymentMode === PaymentMode.BOXOFFICE_CREDIT ||
        shipment_?.service === ShipmentService.INTERNAL_MAIL) &&
      (user.user?.roleName !== "Consulta Innovus" ||
        businessUnit?.type === BusinessType.VIRTUAL_STORE_FOR_INTERNAL_USE)
    );
  }, [shipment_, user, isPaid, businessUnit]);

  const itemsAreModifiable = useMemo(() => {
    return (
      !!shipment_ &&
      shipment_.buConsignee?.code === user?.businessUnit?.code &&
      shipment_.lastBU === user?.businessUnit?.code &&
      shipment_.paymentMode === PaymentMode.COD &&
      !shipment_.document
    );
  }, [shipment_, user]);

  const isDestinationPrintable = useMemo(() => {
    return (
      businessUnit!.code === shipment_?.buConsignee?.code &&
      businessUnit!.code === shipment_.lastBU &&
      liabilityShipments.length > 0
    );
  }, [businessUnit, shipment_, liabilityShipments]);

  const isLiabilityWaiverModificable = useMemo(() => {
    return (
      !!shipment_ &&
      shipment_.buSource?.code === user?.businessUnit?.code &&
      (shipment_.status === ShipmentStatus.ACTIVE ||
        shipment_.status === ShipmentStatus.DRAFT)
    );
  }, [shipment_, user]);

  const showMap = useMemo(() => {
    const buCoordinates = businessUnits.find(
      (b) => b.code === shipment_?.buConsignee?.code
    )?.location.coordinates;
    const consigneeCoordinates = shipment_?.consigneeAddress.coordinates;

    return (
      shipment_?.deliveryType === DeliveryType.AT_HOME &&
      (buCoordinates?.lat !== consigneeCoordinates?.lat ||
        buCoordinates?.lng !== consigneeCoordinates?.lng)
    );
  }, [shipment_, businessUnits]);

  const allProofOfPayments = useMemo(() => {
    let allPOP = true;
    document_?.payments.forEach((payment) => {
      if (
        [
          PaymentMethodEnum.ZELLE,
          PaymentMethodEnum.PAGO_MOVIL_P2C,
          PaymentMethodEnum.TRANSFERENCIA_BANCARIA_INMEDIATA,
          PaymentMethodEnum.PAGO_MERCHANT_TARJETA_CONCILIACION_MANUAL,
        ].includes(payment.paymentMethod.paymentMethodID) &&
        payment.status === PaymentStatusEnum.PENDING &&
        !payment.proofOfPayment
      ) {
        allPOP = false;
      }
    });

    return allPOP;
  }, [document_?.payments]);

  const allowAddIncidence = useMemo(() => {
    return (
      !!shipment_ &&
      (shipment_.status === ShipmentStatus.DRAFT ||
        shipment_.status === ShipmentStatus.ACTIVE) &&
      shipment_.lastBU === user?.businessUnit?.code
    );
  }, [shipment_, user]);

  const handleDocumentView = async () => {
    if (
      !document_?.documentID ||
      (!user.user?.businessUnitList.some(
        (bu) => bu.code === document_?.buCodeInvoicer
      ) &&
        user?.user?.roleName !== "Superadministrador")
    )
      return;

    const document = await getDocument(document_.documentID);
    if (!document) return;

    navigate(`/documents/${document.documentID}`);
  };

  const handlePickup = async () => {
    if (!shipment_?.id) return;

    let coupon: CouponDTO | undefined = undefined;

    // Get real shipments
    loaderService.start();
    const shipments = await Promise.all(
      selectedShipmentNumbers.map((shipmentNumber) =>
        getShipment(shipmentNumber)
      )
    ).then((shipments) => shipments.filter((s) => !!s) as ShipmentInterface[]);

    if (!shipments.length) {
      alertService.error(
        "Hubo un error al obtener los datos completos de cada guía."
      );
      loaderService.stop();
      return;
    }

    // Get document data
    const document = !!shipments[0].document
      ? (await getDocument(
          shipments[0].document?.documentId,
          shipments[0].document?.documentNumber
        )) ?? undefined
      : undefined;

    // Get owner data
    const ownerID = !!document
      ? document.accountOwner?.id
      : shipments[0].paymentMode === PaymentMode.CONTADO ||
        shipments[0].paymentMode === PaymentMode.BOXOFFICE_CREDIT
      ? shipments[0].shipper.id
      : shipments[0].paymentMode === PaymentMode.COD ||
        shipments[0].paymentMode === PaymentMode.DEST_BOXOFFICE_CREDIT
      ? shipments[0].consignee.id
      : undefined;
    const owner = ownerID ? await getAccount(ownerID) : undefined;

    if (!document) {
      // Verify coupons
      const shipment = shipments[0];

      const date = moment();

      // Verify available coupons
      const coupons = await getAvailableCoupons(
        shipments.length,
        businessUnits.find((bu) => bu.code === shipment.buConsignee?.code)!
          .location.locationID!,
        shipment.paymentMode!,
        shipment.deliveryType,
        shipments.reduce((acc, shipment) => acc + +shipment.declaredValue!, 0),
        shipments.reduce(
          (acc, shipment) => acc + +shipment.totalChargedWeight!,
          0
        ),
        date.tz("America/Caracas").format("YYYY-MM-DDTHH:mm:ss")
      );

      if (coupons.didError) {
        alertService.error(
          "Error al obtener los cupones",
          coupons.errorMessage
        );
      }

      if (
        coupons.model?.length &&
        !shipment.items?.some((item) => item.id === "3010")
      ) {
        coupon = coupons.model[0];

        const isBlocked = await verifyAccountBlackList(
          ownerID!,
          coupon.couponID
        );

        if (
          !isBlocked.didError &&
          isBlocked.model !== null &&
          !isBlocked.model
        ) {
          // Redeem coupon
          const redeemedCoupon = await redeemCoupon(
            coupon.couponID,
            shipment.id ?? "",
            shipment.buSource.code,
            shipment.buConsignee?.code ?? "",
            shipments.reduce(
              (acc, shipment) => acc + +shipment.totalChargedWeight!,
              0
            ),
            new Date(),
            user?.user?.userLogin ?? ""
          );

          if (redeemedCoupon.didError) {
            coupon = undefined;
            alertService.error(
              "Error al redimir el cupón",
              redeemedCoupon.errorMessage
            );
          } else {
            const couponItems = redeemedCoupon.model!.items.map((item) => ({
              id: item.itemID.toString(),
              code: item.itemCode,
              name: item.itemName,
              order: 0,
              mandatory: false,
              isItemBase: item.isItemBase,
              rate: {
                value: -redeemedCoupon.model!.couponValue,
                isPercentage: redeemedCoupon.model!.isPercentage,
                iva: 0,
                ipostel: 0,
                distance: 0,
                tierCode: "",
                tierName: "",
              },
            }));

            // Add coupon items to shipments
            for (const shipment of shipments) {
              shipment.items = [...shipment.items, ...couponItems];
            }
          }
        }
      }

      // Get items rate
      for (const shipment of shipments) {
        const internationalItemRate = shipment.items[0].rate;
        const internationalDelivery =
          shipment.service === ShipmentService.STANDARD_INTERNATIONAL ||
          shipment.service === ShipmentService.DOCUMENT_INTERNATIONAL;
        const response = await getShipmentRates(
          shipment.service ?? ShipmentService.STANDARD,
          shipment.paymentMode ?? PaymentMode.COD,
          shipment.deliveryType ?? DeliveryType.AT_OFFICE,
          shipment.buSource?.code ?? "",
          shipment.buConsignee?.code ?? "",
          shipment.shipper.id,
          shipment.consignee.id,
          shipment.accountBillTo?.id,
          shipment.accountSiteID ?? undefined,
          shipment.shipperAddress ??
            businessUnits.find((bu) => bu.code === shipment.buSource?.code!)!
              .location,
          shipment.consigneeAddress,
          shipment.items,
          shipment.pieces,
          shipment.pieces.reduce((acc, p) => acc + p.value, 0) > 0,
          new Date().toISOString(),
          applicationID
        );

        if (response.didError || !response.model) {
          alertService.error(
            `Hubo un error al obtener la tarifa de la guía ${shipment.shipmentNumber}.`
          );
          setOpenModal(false);
          loaderService.stop();
          return;
        }
        if (internationalDelivery) {
          response.model.items[0].rate = internationalItemRate;
          const index = response.model.items.findIndex(
            (item) => item.id === "21"
          );
          if (index !== -1) {
            response.model.items.splice(index, 1);
          }
        }
        shipment.items = response.model.items
          .filter(
            (item) =>
              (item.mandatory ||
                shipment.items?.some((s) => s.id === item.id)) &&
              item.id !== "30"
          )
          .sort((a, b) => a.order - b.order);

        if (coupon) {
          const shipmentUpdated = await updateShipment(
            {
              id: shipment.id,
              items: shipment.items,
              service: shipment.service,
              paymentMode: shipment.paymentMode,
              deliveryType: shipment.deliveryType,
              status: shipment.status,
              pieces: shipment.pieces,
            },
            true,
            false,
            user.user ?? undefined,
            applicationID
          );
          if (shipmentUpdated.didError || !shipmentUpdated.model) {
            alertService.error(
              `Hubo un error al actualizar la guía ${shipment.shipmentNumber}.`
            );
            loaderService.stop();
            return;
          }
        }

        const absoluteTotal = shipment.items
          .filter((item) => !item.rate.isPercentage)
          .reduce((total, item) => total + item.rate.value, 0);
        const percentageTotal = shipment.items
          .filter((item) => item.rate.isPercentage)
          .reduce((total, item) => total + item.rate.value, 0);
        const subtotal = absoluteTotal * (1 + percentageTotal / 100);

        shipment.total = subtotal;
      }
    }

    loaderService.stop();

    dispatch(setPickupOwner(owner ?? undefined));
    dispatch(setPickupPayments([]));
    dispatch(setPickupDocument(document));
    dispatch(setPickupTaxes(document?.taxes ?? []));
    dispatch(setPickupShipments(shipments));
    dispatch(setPickupPhase(PickupPhase.PAYMENT));
    dispatch(setPickupCoupon(coupon));
    navigate("/pick-up");
  };

  const getShipmentDataForModification = async (
    shipment: ShipmentInterface
  ) => {
    const shipmentNumber = shipment.shipmentNumber;
    const buConsignee = businessUnits.find(
      (bu) => bu.code === shipment?.buConsignee?.code
    );
    const deliveryType =
      shipment?.service === ShipmentService.DOCUMENT_INTERNATIONAL ||
      shipment?.service === ShipmentService.STANDARD_INTERNATIONAL
        ? DeliveryType.INTERNATIONAL
        : shipment?.deliveryType;
    const isInternational = deliveryType === DeliveryType.INTERNATIONAL;
    const baseData = {
      buConsignee,
      deliveryType,
      isInternational,
    };

    if (!isInternational) {
      return baseData;
    }

    let countryName = shipment.consigneeAddress.name;
    if (countryName === "Estados Unidos") {
      countryName = "Estados Unidos de América";
    }
    const countryCode = getCode(countryName) ?? getSpanishCode(countryName);
    if (!countryCode) {
      alertService.warn(
        `No se pudo obtener el código del país destino '${countryName}' de la guía ${shipmentNumber}.`
      );
      return baseData;
    }

    const postalCode = shipment.consigneeAddress.postalCode;
    if (!postalCode) {
      alertService.warn(
        `No se conoce el código postal de la ubicación destino de la guía ${shipmentNumber}.`
      );
      return baseData;
    }

    const addressOptions = await addressValidation(countryCode, postalCode);
    if (!addressOptions || addressOptions.address.length === 0) {
      alertService.warn(
        `No se pudo obtener la ubicación destino de la guía ${shipmentNumber}.`
      );
      return baseData;
    }

    const dhlDestination = addressOptions.address[0];
    const destination = shipment.consigneeAddress.reference;
    const internationalAddress = shipment.consigneeAddress;
    const cityName = dhlDestination.cityName;
    const cityValue = dhlAddressStringBuilder(dhlDestination);
    const internationalLocation = {
      country: shipment.consigneeAddress.name,
      city:
        dhlDestination.cityName[0] +
        dhlDestination.cityName.slice(1).toLocaleLowerCase(),
      postalCode,
    };

    return {
      buConsignee,
      deliveryType,
      internationalLocation,
      internationalAddress,
      cityName,
      cityValue,
      dhlDestination,
      destination,
      countryCode,
      isInternational,
    };
  };

  const handleModifyMultiple = async (shipmentNumbers: string[]) => {
    const buSource = businessUnit;
    const accountBillTo = await getAccount(shipment_?.accountBillTo?.id ?? "");

    const shipments = await Promise.all(
      shipmentNumbers.map(async (shipmentNumber) => {
        if (shipmentNumber === shipment_?.shipmentNumber) {
          return {
            ...shipment_,
            ...(await getShipmentDataForModification(shipment_)),
            buSource,
            accountBillTo,
          } as ShipmentInterface;
        } else {
          const shipment = await getShipment(shipmentNumber);

          if (!shipment) {
            alertService.error(
              `Hubo un error obteniendo la guía ${shipmentNumber}`
            );
            return {
              ...shipment_,
              accountBillTo,
              id: undefined,
            } as ShipmentInterface;
          }

          return {
            ...shipment,
            ...(await getShipmentDataForModification(shipment)),
            buSource,
            accountBillTo,
          } as ShipmentInterface;
        }
      })
    );

    if (shipments.some((s) => !s.id)) {
      return;
    }

    dispatch(restartShipmentCreate(shipments));
    navigate(`/shipment-create`);
  };

  const handleModifyClick = async () => {
    if (!shipment_ || !shipment_.shipmentNumber) {
      return;
    }

    if (
      shipment_.paymentMode !== PaymentMode.CONTADO &&
      shipment_.paymentMode !== PaymentMode.BOXOFFICE_CREDIT
    ) {
      return await handleModifyMultiple([shipment_.shipmentNumber]);
    }

    setOpenDocumentCompatibleModal(true);
  };

  const handlePrintShipment = async () => {
    if (!shipment_ || !shipment_.shipmentNumber || !shipment_.service) {
      alertService.error(
        "Error al imprimir la etiqueta",
        "No se encontraron los identificadores de la guia.",
        { autoClose: false }
      );
      return;
    }
    loaderService.start();
    alertService.info(
      "Guía: " + shipment_.shipmentNumber,
      "Imprimiendo etiqueta..."
    );
    const printSucceed = await PrintShipmentLabel(
      +shipment_.shipmentNumber,
      shipment_.service ?? 0,
      shipment_.buSource.code,
      user.user?.userLogin ?? ""
    );
    loaderService.stop();
    if (!!printSucceed) {
      alertService.success(
        "Guía:" + shipment_.shipmentNumber,
        "La etiqueta se imprimió correctamente."
      );
    }
  };

  const handlePrintShipmentPiece = async (pieceNumber: number) => {
    if (!shipment_ || !shipment_.shipmentNumber || !shipment_.service) {
      alertService.error(
        "Error al imprimir la etiqueta",
        "No se encontraron los identificadores de la guia.",
        { autoClose: false }
      );
      return;
    }
    loaderService.start();
    alertService.info(
      "Guía: " + shipment_.shipmentNumber + " - Pieza: " + pieceNumber,
      "Imprimiendo etiqueta..."
    );
    const printSucceed = await PrintPieceLabel(
      +shipment_.shipmentNumber,
      shipment_.service ?? 0,
      shipment_.buSource.code,
      [pieceNumber],
      user.user?.userLogin ?? ""
    );
    loaderService.stop();
    if (!!printSucceed) {
      alertService.success(
        "Guía:" + shipment_.shipmentNumber,
        "La etiqueta se imprimió correctamente."
      );
    }
  };

  const handleDownloadDocuments = async () => {
    if (!shipment_ || !shipment_.shipmentNumber || !shipment_.id) {
      alertService.error(
        "Error al imprimir los documentos",
        "No se encontraron los identificadores de la guia.",
        { autoClose: false }
      );
      return;
    }

    const shipmentDocumentsRequest: ShipmentDeclaredDocumentRequestDto = {
      shipmentNumber: shipment_.shipmentNumber ?? "",
      shipmentHeaderID: shipment_.id,
    };

    loaderService.start();
    alertService.info("Imprimiendo documentos...");
    const fileResult = await getAllDeclaredShipmentDocuments(
      [shipmentDocumentsRequest],
      shipment_.document?.documentId
    );
    loaderService.stop();
    if (!!fileResult) {
      // Create a URL for the Blob
      const fileURL = URL.createObjectURL(fileResult.file);

      // Create a link element
      const a = document?.createElement("a");
      a.href = fileURL;
      a.download = fileResult.fileName; // Set the filename for the downloaded file
      a.click();

      /// In case need to force print
      /*const printWindow = window.open(fileURL, "_blank");
      if (printWindow) {
        printWindow.onload = () => {
          printWindow.print();
        };
      } else {
        console.error("Could not open print window");
      }*/

      // Remember to handle Blob URL cleanup when done
      URL.revokeObjectURL(fileURL);
      alertService.success("Documento impreso satisfactoriamente.");
    } else {
      alertService.error("No se pudo descargar el documento.");
    }
  };

  const handleDownloadPOD = async () => {
    if (liabilityShipments.length === 0) {
      alertService.error("No existe declaración jurada firmada digitalmente.");
      return;
    }

    loaderService.start();
    alertService.info("Descargando documentos...");

    const fileResult = await getPODDocument(liabilityShipments);

    loaderService.stop();
    if (fileResult) {
      const fileURL = URL.createObjectURL(fileResult.file);

      const a = document.createElement("a");
      a.href = fileURL;
      a.download = fileResult.fileName;
      a.click();

      URL.revokeObjectURL(fileURL);
      alertService.success("Documento impreso satisfactoriamente.");
    } else {
      alertService.error("No se pudo descargar el documento del POD.");
    }
  };

  const handleDownloadDigitalDocs = async (file: FileDocument) => {
    const fileURL = URL.createObjectURL(file.file);

    const a = document.createElement("a");
    a.href = fileURL;
    a.download = file.fileName;
    a.click();

    URL.revokeObjectURL(fileURL);
  };

  const handleViewDigitalDocs = async (file: FileDocument) => {
    const fileURL = URL.createObjectURL(file.file);
    window.open(fileURL, "_blank");
  };

  const handleDropdownMenuSelect = (option: { value: PrintOption }) => {
    setOpenModal(false);
    if (option.value === PrintOption.SHIPMENT) {
      handlePrintShipment();
    } else if (option.value === PrintOption.DOCUMENT) {
      handleDownloadDocuments();
    } else {
      handleDownloadPOD();
    }
  };

  const redirectToGoogleMaps = () => {
    const lat = shipment_?.consigneeAddress?.coordinates.lat ?? 0;
    const lng = shipment_?.consigneeAddress?.coordinates.lng ?? 0;
    const googleMapsUrl = `https://www.google.com/maps/search/?api=1&query=${lat},${lng}`;
    window.open(googleMapsUrl, "_blank");
  };

  const handleAnulation = async () => {
    if (!shipment_?.id) return;

    const response = await updateShipmentStatus(
      ShipmentStatus.ANNULLED,
      shipment_?.id,
      shipment_?.shipmentNumber ?? "",
      user.user ?? undefined
    );

    if (response.didError) {
      alertService.error(
        "Error al anular la guía",
        response.errorMessage ?? "No se pudo anular la guía."
      );
    } else {
      alertService.success("Guía anulada", "La guía se anuló correctamente.");
      updateModalShipment();
      setOpenAnnulation(false);
    }
  };

  const updateModalShipment = async () => {
    if (!shipmentNumber || !!shipment || !openModal) return;

    getShipment(shipmentNumber).then((shipment) => {
      if (!shipment) {
        alertService.error(`No se pudo cargar la guía ${shipmentNumber}.`);
        setOpenModal(false);
        return;
      }

      if (!shipment.document) {
        const internationalDelivery =
          shipment.service === ShipmentService.STANDARD_INTERNATIONAL ||
          shipment.service === ShipmentService.DOCUMENT_INTERNATIONAL;

        getShipmentRates(
          shipment.service ?? ShipmentService.STANDARD,
          shipment.paymentMode ?? PaymentMode.COD,
          shipment.deliveryType,
          businessUnits.find((bu) => bu.code === shipment.buSource?.code!)!
            .code ?? "",
          shipment.buConsignee?.code ?? "",
          shipment.shipper.id,
          shipment.consignee.id,
          shipment.accountBillTo?.id,
          shipment.accountSiteID ?? undefined,
          shipment.shipperAddress ??
            businessUnits.find((bu) => bu.code === shipment.buSource?.code!)
              ?.location,
          shipment.consigneeAddress,
          shipment.items,
          shipment.pieces,
          shipment.pieces.reduce((acc, p) => acc + p.value, 0) > 0,
          new Date().toISOString(),
          applicationID
        ).then(async (response) => {
          if (response.didError || !response.model) {
            alertService.error(
              `Hubo un error al obtener la tarifa de la guía ${shipment.shipmentNumber}.`
            );
            return;
          }

          if (internationalDelivery) {
            let countryName = shipment.consigneeAddress.name;
            if (countryName === "Estados Unidos") {
              countryName = "Estados Unidos de América";
            }
            const countryCode =
              getCode(countryName) ?? getSpanishCode(countryName);

            if (!countryCode) {
              alertService.warn(
                `No se pudo obtener el código del país destino '${countryName}' de la guía ${shipmentNumber}.`
              );
              return;
            }

            const postalCode = shipment.consigneeAddress.postalCode;
            if (!postalCode) {
              alertService.warn(
                `No se conoce el código postal de la ubicación destino de la guía ${shipmentNumber}.`
              );
              return;
            }

            const addressOptions = await addressValidation(
              countryCode,
              postalCode
            );
            if (!addressOptions || addressOptions.address.length === 0) {
              alertService.warn(
                `No se pudo obtener la ubicación destino de la guía ${shipmentNumber}.`
              );
              return;
            }

            const dhlDestination = addressOptions.address[0];
            const { packages } = convertPieceToDhlPackageDto(shipment.pieces);
            const [address1, address2, address3] = splitAddress(
              shipment.consigneeAddress.reference ?? ""
            );

            const DHLrates = await getRatesDHL({
              receiverPostalCode: dhlDestination.postalCode,
              receiverCountyName: dhlDestination.countyName,
              receiverCityName: dhlDestination.cityName,
              receiverCountryCode: countryCode,
              receiverAddressLine1: address1,
              receiverAddressLine2: address2,
              receiverAddressLine3: address3,
              packages: packages,
              declaredValue: !!shipment.declaredValue
                ? +shipment.declaredValue
                : 0,
              isCustomsDeclarable:
                shipment.service === ShipmentService.STANDARD_INTERNATIONAL,
            });

            if (!DHLrates) {
              alertService.warn(
                `No se pudo obtener la tarifa de DHL para la guía ${shipment.shipmentNumber}.`
              );
              return;
            }

            // Update dhl item
            const dhlItem = convertRatesDHLResponseToItemInterface(
              DHLrates,
              exchanges
            );
            const oldDhlItem = response.model.items.find(
              (item) => item.id === "24" || item.id === "18"
            );
            if (oldDhlItem) {
              oldDhlItem.rate = dhlItem.rate;
            }

            // Delete delivery item
            const index = response.model.items.findIndex(
              (item) => item.id === "21"
            );
            if (index !== -1) {
              response.model.items.splice(index, 1);
            }
          }

          const rates = response.model.items;
          setAproximated(true);
          setDeliveryDistance(
            response.model?.deliveryDistance ?? shipment.deliveryDistance ?? 0
          );
          setPickupDistance(
            response.model?.pickupDistance ?? shipment.pickupDistance ?? 0
          );

          setShipment({
            ...shipment,
            items: rates,
            total: rates.reduce((acc, i) => acc + i.rate.value, 0),
          });
        });
      } else {
        setDeliveryDistance(shipment.deliveryDistance ?? 0);
        setPickupDistance(shipment.pickupDistance ?? 0);
        setShipment(shipment);
      }

      setSelectedShipmentNumbers([shipment.shipmentNumber!]);
    });
  };

  const estimatedDeliveryDate = useMemo(() => {
    if (
      estimatedDeliveryTime === undefined ||
      (shipment_?.service !== ShipmentService.ECONOMIC &&
        shipment_?.service !== ShipmentService.SAVER)
    ) {
      return;
    }

    const holidaySet = new Set(
      holidays.map((h) => moment(h.date).format("YYYY-MM-DD"))
    );
    let remainingDays = estimatedDeliveryTime;
    let currentDay = moment(shipment_?.createdAt);

    while (remainingDays > 0) {
      currentDay = currentDay.add(1, "days");

      if (
        currentDay.weekday() !== 5 &&
        currentDay.weekday() !== 6 &&
        !holidaySet.has(currentDay.format("YYYY-MM-DD"))
      ) {
        remainingDays -= 1;
      }
    }

    return currentDay.format("YYYY-MM-DD");
  }, [
    estimatedDeliveryTime,
    shipment_?.createdAt,
    holidays,
    shipment_?.service,
  ]);

  const getDigitalLiabilityWaiver = async (option?: string) => {
    loaderService.start();
    const shipmentId: DigitalDocsInterfaceRequest = {
      list: [{ shipmentHeaderID: shipment_?.id! }],
    };
    const liabilityWaiver = await getLiabilityWaiverDigitalDoc(shipmentId);

    if (liabilityWaiver) {
      if (option === "v") {
        handleViewDigitalDocs(liabilityWaiver);
      } else if (option === "d") {
        handleDownloadDigitalDocs(liabilityWaiver);
      }
    }
    loaderService.stop();
  };

  const getDigitalPOD = async (option?: string) => {
    loaderService.start();
    const shipmentId: DigitalDocsInterfaceRequest = {
      list: [{ shipmentHeaderID: shipment_?.id! }],
    };

    const POD = await getPODDigitalDoc(shipmentId);

    if (POD) {
      if (option === "v") {
        handleViewDigitalDocs(POD);
      } else if (option === "d") {
        handleDownloadDigitalDocs(POD);
      }
    }
    loaderService.stop();
  };

  const getShipmentTrackingList = useCallback(
    async (userLogin: string) => {
      const buCode = businessUnit?.code;
      const shipmentHeaderID = shipment_?.id;

      if (!userLogin || !shipmentHeaderID || !buCode) return;

      const response = await getEventTrackingList(
        [
          {
            objectID: shipmentHeaderID,
            objectTypeID: 10,
            userLogin: userLogin,
            buCode: buCode,
          },
        ],
        applicationID
      );

      if (!response.didError && response?.model) {
        setTrackingList(response.model);
      }
    },
    [shipment_?.id, businessUnit?.code, applicationID]
  );

  const handleIncidenceSubmit = async (values: IncidenceFormValues) => {
    const userLogin = user.user?.userLogin;
    const shipmentID = shipment_?.id;
    const shipmentNumber = shipment_?.shipmentNumber;
    const paymentMode = shipment_?.paymentMode;
    const incidenceID = values.incidence?.incidenceID;
    const reasonID = values.reason?.reasonListID;
    const incidenceActionID = values.action?.incidenceActionID;
    const buCode = businessUnit?.code;
    let buCodeHoldAt = "";
    let pieces = values.pieces
      .filter((piece) => piece.checked && piece.value !== null)
      .map((piece) => piece.value!);

    if (
      !userLogin ||
      !shipmentID ||
      !shipmentNumber ||
      !paymentMode ||
      !incidenceID ||
      !reasonID ||
      !buCode ||
      !incidenceActionID
    ) {
      return;
    }

    loaderService.start();

    if (incidenceActionID === 1) {
      values.businessUnit = shipment_.buSource;
      values.location = shipment_.buSource.location;
    }
    if (incidenceActionID === 3) {
      buCodeHoldAt = "ALM";
    }

    const newBUCodeConsignee = [1, 9].includes(incidenceActionID)
      ? values.businessUnit?.code
      : incidenceActionID === 3
      ? "ALM"
      : undefined;

    const response = await addIncidence(
      shipmentID,
      shipmentNumber,
      incidenceID,
      reasonID,
      incidenceActionID,
      buCode,
      pieces,
      userLogin,
      buCodeHoldAt,
      newBUCodeConsignee,
      shipment_?.paymentMode,
      values.deliveryType ?? undefined,
      values.location?.coordinates.lat,
      values.location?.coordinates.lng,
      values.location?.address,
      undefined,
      values.location?.name,
      values.location?.reference
    );

    if (response.didError) {
      alertService.error(
        "Hubo un error agregando la incidencia",
        response.errorMessage
      );
      loaderService.stop();
      return;
    }

    // Returns to origin or warehouse
    if (
      incidenceActionID === 1 ||
      incidenceActionID === 3 ||
      incidenceActionID === 9
    ) {
      let newShipment = "";
      const regex = /nuevo número de guía:\s*(\d+)\s*$/i;
      const match = response.message.match(regex);
      if (match && match[1]) {
        newShipment = match[1];
      }

      let message = `La incidencia se agregó con éxito, se creó la guía de sustitución ${newShipment}.`;
      let NewShipmentData = await getShipment(newShipment);
      setnewShipmentSubtituteIncidence({
        shipmentNumber: parseInt(NewShipmentData?.shipmentNumber ?? "0"),
        service: NewShipmentData?.service ?? 0,
        buSource: NewShipmentData?.buSource.code ?? "",
        userLogin: user.user?.userLogin ?? "",
      });
      updateModalShipment();
      setSubstitutionShipmentIncidence(message);
      setOpenSubstitutionIncidenceModal(true);
    }

    await getShipmentTrackingList(userLogin);
    loaderService.stop();
    alertService.success("Incidencia agregada con éxito");
    setShowIncidenceForm(false);
  };

  useEffect(() => {
    getShipmentTrackingList(userLogin);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [getShipmentTrackingList]);

  useEffect(() => {
    updateModalShipment();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    shipmentNumber,
    shipment,
    openModal,
    businessUnits,
    refresh,
    setOpenModal,
  ]);

  useEffect(() => {
    const getShipmentService = async () => {
      if (!shipment_?.service || !openModal) return;

      const service = await getService(shipment_.service);

      if (service.didError || !service.model) {
        return;
      }

      setService(service.model);
    };

    getShipmentService();
  }, [shipment_, openModal]);

  useEffect(() => {
    if (!shipment && openModal) {
      setDelivered(false);
      setShipment(undefined);
      setSelectedShipmentNumbers([]);
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [openModal]);

  useEffect(() => {
    setShipment(shipment);
    setDeliveryDistance(shipment?.deliveryDistance ?? 0);
    setPickupDistance(shipment?.pickupDistance ?? 0);
  }, [shipment]);

  useEffect(() => {
    const documentID = shipment_?.document?.documentId;
    if (!documentID) {
      setDocument(undefined);
      return;
    }

    const fetchDocument = async () => {
      const document = await getDocument(documentID);
      if (!document) {
        setDocument(undefined);
        return;
      }

      setDocument(document);
    };

    fetchDocument();
  }, [shipment_]);

  useEffect(() => {
    const service = shipment_?.service;
    const buSource = shipment_?.buSource?.code;
    const shipmentNumber = shipment_?.shipmentNumber;

    if (!shipmentNumber || !service || !buSource) return;

    const getTracking = async () => {
      const tracking = await getShipmentTracking(
        shipmentNumber,
        service,
        buSource
      );
      if (!tracking) return;

      setTracking(
        tracking.sort((a, b) => {
          return new Date(a.date).getTime() - new Date(b.date).getTime();
        })
      );
    };

    getTracking();
  }, [shipment_]);

  useEffect(() => {
    setCenter({
      lat: shipment_?.consigneeAddress?.coordinates.lat ?? 0,
      lng: shipment_?.consigneeAddress?.coordinates.lng ?? 0,
    });
  }, [shipment_]);

  useEffect(() => {
    if (
      !openModal ||
      estimatedDeliveryTime !== undefined ||
      !shipment_?.shipmentNumber
    ) {
      return;
    }

    const afunction = async () => {
      const response = await getShipmentEstimatedDeliveryTime(
        shipment_?.shipmentNumber
      );

      if (response.didError || response.model === null) {
        return;
      }

      setEstimatedDeliveryTime(response.model);
    };

    afunction();
  }, [openModal, estimatedDeliveryTime, shipment_?.shipmentNumber]);

  useEffect(() => {
    const getLiabilityShipments = async () => {
      let liabilityShipments: string[] = [];

      for (let shipmentNumber of selectedShipmentNumbers) {
        const shipmentHeader = await getShipment(shipmentNumber);

        if (shipmentHeader) {
          const response = await searchLiabilityWaiver({
            shipmentHeaderID: shipmentHeader.id,
          });
          if (!!response.didError || !response.model) {
            alertService.error(
              `Hubo un error al buscar la declaración jurada de la guía ${shipmentNumber}.`
            );
            loaderService.stop();
            return;
          }
          if (response.model.length > 0) {
            if (!response.model[0].isPhysicalLiabilityWaiver)
              liabilityShipments.push(shipmentNumber);
          }
        }
      }
      setLiabilityShipments(liabilityShipments);
    };

    getLiabilityShipments();
  }, [selectedShipmentNumbers]);

  useEffect(() => {
    const getDigitalDocumentsStatus = async () => {
      const response = await getDigitalDocsStatus(shipment_?.id ?? "");
      if (!response.model || response.didError) {
        alertService.error(
          "Error al obtener el estado de los documentos digitales",
          response.errorMessage
        );
      } else {
        setIsPhysicalLiability(response.model.isPhysicalLiabilityWaiver);
        setIsPhysicalPOD(response.model.isPhysicalPOD);
      }
    };

    if (shipment_) getDigitalDocumentsStatus();

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [shipment_]);

  useEffect(() => {
    const shipmentHeaderID = shipment_?.id;
    if (!shipmentHeaderID) {
      setShipmentContentInvoices([]);
      return;
    }

    const afunction = async () => {
      const response = await getAllShipmentContentInvoice(shipmentHeaderID);

      if (response.didError || !response.model) {
        setShipmentContentInvoices([]);
        return;
      }

      setShipmentContentInvoices(response.model);
    };

    afunction();
  }, [shipment_?.id]);

  return (
    <>
      <Modal
        openModal={openModal}
        setOpenModal={setOpenModal}
        className="bg-gray-200 w-auto sm:w-11/12 md:w-4/5 lg:w-3/4 xl:w-2/3 2xl:w-3/5 max-h-screen overflow-y-auto"
      >
        <div
          className={classNames(
            "p-4 flex flex-1 flex-col gap-2 mb-8 mx-aut max-w-full",
            (!shipment_ || delivered) && "hidden"
          )}
          style={{ maxWidth: "100%" }}
        >
          <div
            className={classNames(
              "bg-white rounded-lg shadow-sm w-full overflow-hidden"
            )}
          >
            {/* Header */}
            <div className="flex flex-row justify-between p-4 gap-3 border-b">
              <div className="flex flex-col">
                <div className="flex flex-row flex-wrap items-baseline gap-2">
                  <p className="font-bold text-lg sm:text-xl">Guía:</p>
                  <p className="text-indigo-600 font-bold text-lg sm:text-xl truncate">
                    {shipmentNumber}
                  </p>

                  <p
                    className={classNames(
                      "font-bold text-xl text-gray-800",
                      !shipment_?.status && "hidden"
                    )}
                  >
                    (
                    {shipmentStatusFormat(
                      shipment_?.status ?? ShipmentStatus.ACTIVE
                    )}
                    )
                  </p>
                </div>

                <div className="flex flex-row flex-wrap gap-2 text-sm mt-1">
                  <p className="text-gray-600">Creación:</p>
                  <p className="text-gray-800 font-semibold text-sm">
                    {!!shipment_?.createdAt &&
                      new Date(shipment_.createdAt)
                        .toLocaleDateString("es-VE", {
                          year: "numeric",
                          month: "2-digit",
                          day: "2-digit",
                          hour: "2-digit",
                          minute: "2-digit",
                        })
                        .replace("a", "AM")
                        .replace("p", "PM")
                        .slice(0, -4)}
                  </p>
                </div>
                {/* Substitute links */}
                <div className="flex flex-col gap-2">
                  <div
                    className={classNames(
                      "flex flex-row items-center text-base gap-2",
                      !shipment_?.substituteFor && "hidden"
                    )}
                  >
                    <p>Sustituto de:</p>
                    <LinkText
                      text={shipment_?.substituteFor ?? ""}
                      onClick={() => {
                        setOpenModal(false);
                        navigate(`/shipments/${shipment_?.substituteFor}`);
                      }}
                    />
                  </div>

                  <div
                    className={classNames(
                      "flex flex-row items-center text-base gap-2",
                      !shipment_?.substitutedBy && "hidden"
                    )}
                  >
                    <p>Sustituido por:</p>
                    <LinkText
                      text={shipment_?.substitutedBy ?? ""}
                      onClick={() => {
                        setOpenModal(false);
                        navigate(`/shipments/${shipment_?.substitutedBy}`);
                      }}
                    />
                  </div>
                </div>
              </div>
              <div className="flex items-center justify-end">
                <button
                  type="button"
                  className="flex items-center justify-center relative rounded-md bg-white text-gray-400 hover:text-gray-500 focus:outline-none focus:ring-2 focus:ring-indigo-500 p-2"
                  onClick={() => setOpenModal(false)}
                >
                  <span className="sr-only">Close panel</span>
                  <XMarkIcon className="h-6 w-6" aria-hidden="true" />
                </button>
              </div>
            </div>

            <div className={classNames("p-4")}>
              {/* Main data */}
              <div className="flex flex-col lg:flex-row gap-4">
                {/*Shipper & Consignee */}
                <div className="flex flex-col md:flex-row justify-between gap-6 flex-1 min-w-0">
                  <div className="flex-1 max-w-1/3">
                    <ShipmentDetailsClientData
                      isShipper
                      client={shipment_?.shipper}
                      businessUnit={shipment_?.buSource}
                      shipment={shipment}
                    />
                  </div>

                  <div className="flex-1 max-w-1/3">
                    <ShipmentDetailsClientData
                      client={shipment_?.consignee}
                      businessUnit={shipment_?.buConsignee}
                      location={shipment_?.consigneeAddress}
                      showLocation={shipment_?.deliveryType === 20}
                      shipment={shipment}
                    />
                  </div>
                </div>

                {/* Resume */}
                <div className="flex flex-col lg:items-end text-gray-800 leading-tight max-w-1/3 lg:w-52 flex-shrink-0">
                  <p className="font-medium text-base leading-none">
                    {paymentModeFormat(shipment_?.paymentMode).toUpperCase()}
                  </p>
                  <p className="mb-2">
                    Servicio:{" "}
                    <span className="font-semibold text-sm">
                      {service?.serviceShortName}
                    </span>
                  </p>
                  <p
                    className={classNames(
                      "leading-none mb-2",
                      shipment_?.paymentMode !== PaymentMode.CREDIT && "hidden"
                    )}
                  >
                    {shipment_?.accountBillTo?.accountFullName}
                  </p>
                  <p
                    className={classNames(
                      "font-semibold",
                      shipment_?.service === ShipmentService.INTERNAL_MAIL &&
                        "hidden"
                    )}
                  >
                    <span className="font-normal">Con impuestos: </span>
                    {currencyExchangeText(totalWithTaxes, exchanges, "USD")}
                  </p>
                  <p>
                    Nº de piezas:{" "}
                    <span className="font-semibold">
                      {shipment_?.pieces.length}
                    </span>
                  </p>
                  <p
                    className={classNames(
                      shipment_?.service === ShipmentService.INTERNAL_MAIL &&
                        "hidden"
                    )}
                  >
                    {!!document_?.urlDocument
                      ? "Peso facturado: "
                      : "Peso por facturar: "}
                    <span className="font-semibold">
                      {shipment_?.totalChargedWeight?.toFixed(2)} Kg
                    </span>
                  </p>

                  {/* Small stats */}
                  <div className="text-xs mt-2 w-full lg:text-right">
                    <div
                      hidden={
                        shipment_?.service ===
                          ShipmentService.STANDARD_INTERNATIONAL ||
                        shipment_?.service ===
                          ShipmentService.DOCUMENT_INTERNATIONAL
                      }
                    >
                      Peso balanza:{" "}
                      <span className="font-semibold">
                        {shipment_?.totalPhysicalWeight?.toFixed(2)} Kg
                      </span>
                    </div>
                    <div
                      hidden={
                        shipment_?.service ===
                          ShipmentService.STANDARD_INTERNATIONAL ||
                        shipment_?.service ===
                          ShipmentService.DOCUMENT_INTERNATIONAL
                      }
                    >
                      Peso volumétrico:{" "}
                      <span className="font-semibold">
                        {shipment_?.totalDimensionalWeight?.toFixed(2)} Kg
                      </span>
                    </div>
                    <div
                      hidden={
                        shipment_?.service ===
                          ShipmentService.STANDARD_INTERNATIONAL ||
                        shipment_?.service ===
                          ShipmentService.DOCUMENT_INTERNATIONAL
                      }
                    >
                      Factor volumétrico:{" "}
                      <span className="font-semibold">
                        {shipment_?.dimensionalFactor?.toFixed(0)}
                      </span>
                    </div>
                  </div>
                </div>
              </div>

              <hr className="my-4" />

              {/* Details */}
              <div className="flex flex-1 flex-col gap-4">
                <div className="flex items-center w-full gap-4">
                  <p className="font-light text-xl">Detalles</p>

                  <div
                    className={classNames(
                      "p-2 hover:bg-gray-200 border cursor-pointer rounded-full",
                      pickupMode &&
                        "bg-gray-100 opacity-500 pointer-events-none"
                    )}
                    onClick={() => setDetails(!details)}
                  >
                    <ChevronDownIcon
                      style={{
                        transform: `rotate(${!details ? 0 : 180}deg)`,
                        transitionDuration: `${details}ms`,
                      }}
                      className="h-6 w-6 flex-none text-gray-400 transition-all ease-in-out duration-400"
                      aria-hidden="true"
                    />
                  </div>
                </div>

                <AnimatedHeight
                  duration={1000}
                  active={details}
                  className="flex flex-col px-2 gap-6"
                >
                  <div
                    className={classNames(
                      "flex flex-col",
                      !document_ && "hidden"
                    )}
                  >
                    <p className="font-medium text-gray-800 text-lg">Factura</p>
                    <div className="overflow-x-auto mt-4">
                      <table className="table-auto w-full min-w-[40rem]">
                        <thead>
                          <tr>
                            <th className="text-left px-4 py-2 font-semibold text-xs">
                              ID FACTURA
                            </th>
                            <th className="text-left px-4 py-2 font-semibold text-xs">
                              FECHA DE FACTURA
                            </th>
                            <th className="text-left px-4 py-2 font-semibold text-xs truncate">
                              A NOMBRE DE
                            </th>
                            <th className="text-left px-4 py-2 font-semibold text-xs truncate">
                              TOTAL FACTURA
                            </th>
                            <th className="text-left px-4 py-2 font-semibold text-xs truncate">
                              MONTO POR COBRAR
                            </th>
                            <th className="text-left px-4 py-2 font-semibold text-xs truncate">
                              MONTO A REINTEGRAR
                            </th>
                            {/* HIDE until developed}
                            <th className="text-left px-4 py-2 font-semibold text-xs truncate">
                              CANT. DE GUIAS
                            </th>
                            */}
                            <th className="text-right px-4 py-2 font-semibold text-xs">
                              ESTADO
                            </th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr
                            className={classNames(
                              "bg-gray-50",
                              (user.user?.businessUnitList.some(
                                (bu) => bu.code === document_?.buCodeInvoicer
                              ) ||
                                user?.user?.roleName ===
                                  "Superadministrador") &&
                                "cursor-pointer hover:bg-gray-100 "
                            )}
                            onClick={handleDocumentView}
                          >
                            <td
                              className="px-4 py-4 text-xs text-gray-500 font-semibold truncate"
                              style={{ maxWidth: 160 }}
                            >
                              {document_?.documentNumber}
                            </td>

                            <td className="px-4 py-4 text-xs text-gray-500 font-semibold">
                              {!!document_?.documentDate &&
                                formatDate(
                                  document_.documentDate?.toISOString()
                                )}
                            </td>

                            <td className="px-4 py-4 text-xs text-gray-500 font-semibold truncate">
                              {document_?.accountOwner?.accountFullName}
                            </td>

                            <td className="px-4 py-4 text-xs text-gray-500 font-semibold">
                              <span className="font-medium">
                                {currencyExchangeText(
                                  document_?.total ?? 0,
                                  exchanges,
                                  "USD"
                                )}
                              </span>
                            </td>

                            <td className="px-4 py-4 text-xs text-gray-500 font-semibold">
                              <span className="font-medium">
                                {currencyExchangeText(
                                  Math.max(0, document_?.balanceAmount ?? 0),
                                  exchanges,
                                  "USD"
                                )}
                              </span>
                            </td>

                            <td className="px-4 py-4 text-xs text-gray-500 font-semibold">
                              <span className="font-medium">
                                {currencyExchangeText(
                                  (document_?.balanceAmount ?? 0) < 0
                                    ? -1 * document_?.balanceAmount!
                                    : 0,
                                  exchanges,
                                  "USD"
                                )}
                              </span>
                            </td>
                            <td className="px-4 py-4 text-xs text-right text-gray-500 font-semibold truncate">
                              {documentStatusFormat(
                                document_?.status ?? DocumentStatus.PENDING
                              )}
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>

                  <hr className={classNames("my-4", !document_ && "hidden")} />

                  <div
                    className={classNames(
                      "flex flex-col",
                      !shipment_ && "hidden"
                    )}
                  >
                    <p className="font-medium text-gray-800 text-xl">Piezas</p>
                    <div className="overflow-x-auto">
                      <PieceTable
                        pieces={shipment_?.pieces ?? []}
                        printable={isPrintable}
                        onPrint={handlePrintShipmentPiece}
                      />
                    </div>
                  </div>

                  <hr
                    className={classNames(
                      "my-8",
                      (!shipment_ ||
                        shipment_.service === ShipmentService.INTERNAL_MAIL) &&
                        "hidden"
                    )}
                  />

                  <div
                    className={classNames(
                      "flex flex-col",
                      (!shipment_ ||
                        shipment_.service === ShipmentService.INTERNAL_MAIL) &&
                        "hidden"
                    )}
                  >
                    <p className="font-medium text-gray-800 text-xl mb-4">
                      Items
                    </p>
                    <div className="overflow-x-auto">
                      <ShipmentItemTable
                        showTaxes
                        total={shipment_?.total ?? 0}
                        items={shipment_?.items ?? []}
                        deliveryDistance={deliveryDistance}
                        pickupDistance={pickupDistance}
                        ipostel={ipostel ?? 0}
                        declaredValue={+(shipment_?.declaredValue ?? "0")}
                        exchanges={exchanges}
                      />
                    </div>
                    {aproximated && (
                      <p className="text-xs text-right text-gray-400">
                        *Los montos son estimados.
                      </p>
                    )}
                  </div>

                  <hr
                    className={classNames(
                      "my-4",
                      !shipment_?.observations && "hidden"
                    )}
                  />

                  <div
                    className={classNames(
                      "flex flex-col",
                      !shipment_?.observations && "hidden"
                    )}
                  >
                    <p className="font-medium text-gray-800 text-xl mb-4">
                      Observaciones
                    </p>
                    <p className="text-gray-800">{shipment_?.observations}</p>
                  </div>

                  <hr
                    className={classNames(
                      "my-4",
                      !shipment_?.deliveryCreationUser && "hidden"
                    )}
                  />

                  <div
                    className={classNames(
                      "flex flex-col",
                      !shipment_?.deliveryCreationUser && "hidden"
                    )}
                  >
                    <p className="font-medium text-gray-800 text-xl mb-4">
                      Entrega
                    </p>
                    <p className="text-gray-800">
                      <span className="font-semibold">Usuario:</span>{" "}
                      {shipment_?.deliveryCreationUser}
                    </p>
                    <p className="text-gray-800">
                      <span className="font-semibold">Fecha:</span>{" "}
                      {moment(shipment_?.deliveryDate).format("YYYY-MM-DD")}
                    </p>
                    <p className="text-gray-800">
                      <span className="font-semibold">Observaciones:</span>{" "}
                      {shipment_?.deliveryObservation}
                    </p>
                  </div>

                  {/* {Digital docs} */}
                  {(isPhysicalLiability !== null ||
                    isPhysicalPOD !== null ||
                    shipmentContentInvoices.length > 0) && (
                    <>
                      <hr className="my-4" />
                      <div className="flex flex-col">
                        <p className="font-medium text-gray-800 text-xl mb-4">
                          Documentos Digitales
                        </p>
                        {isPhysicalLiability !== null && (
                          <div className="flex flex-col gap-2">
                            <div className="flex flex-col gap-2">
                              <div className="flex flex-row flex-wrap items-center gap-2">
                                <p className="font-semibold text-gray-800 text-md">
                                  Declaración Jurada:
                                </p>
                                {isPhysicalLiability ? (
                                  <>
                                    <p className="ml-2">
                                      Llenada en el documento físico
                                    </p>
                                    {isLiabilityWaiverModificable && (
                                      <LinkText
                                        text="Agregar Declaración Jurada digital"
                                        onClick={(e) =>
                                          setOpenLiabilityWaiverModal(true)
                                        }
                                        className="ml-4"
                                      />
                                    )}
                                  </>
                                ) : (
                                  <>
                                    <LinkText
                                      text="Ver Declaración Jurada"
                                      onClick={() =>
                                        getDigitalLiabilityWaiver("v")
                                      }
                                      className="ml-2"
                                    />
                                    <LinkText
                                      text="Descargar Declaración Jurada"
                                      onClick={() =>
                                        getDigitalLiabilityWaiver("d")
                                      }
                                      className="ml-2"
                                    />
                                    {isLiabilityWaiverModificable && (
                                      <LinkText
                                        text="Modificar Declaración Jurada"
                                        onClick={(e) =>
                                          setOpenLiabilityWaiverModal(true)
                                        }
                                        className="ml-4"
                                      />
                                    )}
                                  </>
                                )}
                              </div>
                            </div>
                          </div>
                        )}

                        <div
                          className={classNames(
                            "flex flex-row flex-wrap items-center gap-2",
                            shipment_?.status !== ShipmentStatus.DELIVERED &&
                              "hidden"
                          )}
                        >
                          <p className="font-semibold text-gray-800 text-md">
                            POD:
                          </p>
                          {isPhysicalPOD ? (
                            <p className="ml-2">
                              Llenado en el documento físico
                            </p>
                          ) : (
                            <>
                              <LinkText
                                text="Ver POD"
                                onClick={() => getDigitalPOD("v")}
                                className="ml-2"
                              />
                              <LinkText
                                text="Descargar POD"
                                onClick={() => getDigitalPOD("d")}
                                className="ml-2"
                              />
                            </>
                          )}
                        </div>
                      </div>
                    </>
                  )}

                  <hr
                    className={classNames(
                      "my-4",
                      !estimatedDeliveryDate && "hidden"
                    )}
                  />

                  <div
                    className={classNames(
                      "flex flex-col",
                      !estimatedDeliveryDate && "hidden"
                    )}
                  >
                    <p className="font-medium text-gray-800 text-xl mb-4">
                      Fecha de entrega estimada
                    </p>
                    <p className="text-gray-800">{estimatedDeliveryDate}</p>
                  </div>

                  <hr
                    className={classNames(
                      "my-4",
                      tracking.length === 0 && "hidden"
                    )}
                  />

                  <div
                    className={classNames(
                      "flex flex-col",
                      tracking.length === 0 && "hidden"
                    )}
                  >
                    <p className="font-medium text-gray-800 text-xl mb-4">
                      Tracking
                    </p>
                    <div
                      className={classNames(
                        "flex flex-col md:flex-row items-end  gap-4 mb-4",
                        process.env.REACT_APP_PRODUCTION !== "false" && "hidden"
                      )}
                    >
                      <div className="flex flex-col items-end gap-3 w-full">
                        <div className="flex-1 flex gap-2 items-center w-full">
                          <div className="flex-1 min-w-0">
                            <FormTextInput
                              isRequiredLabel
                              name="userLogin"
                              value={userLogin}
                              placeholder="Nombre de usuario"
                              onChange={(e) => setUserLogin(e.target.value)}
                              className="w-full"
                            />
                          </div>

                          <PrimaryButton
                            onClick={() => getShipmentTrackingList(userLogin)}
                            className="whitespace-nowrap"
                          >
                            Buscar
                          </PrimaryButton>
                        </div>
                      </div>
                    </div>

                    <div className="overflow-x-auto">
                      <table className="table-auto w-full min-w-[40rem] mb-8">
                        <colgroup>
                          <col style={{ width: "13rem" }} />
                          <col />
                        </colgroup>
                        <thead>
                          <tr>
                            <th className="text-left px-2 py-2 font-semibold text-xs">
                              FECHA
                            </th>
                            <th className="text-left px-2 py-2 font-semibold text-xs">
                              EVENTO
                            </th>
                          </tr>
                        </thead>
                        <tbody>
                          {trackingList.map((t, i) => (
                            <tr
                              key={i}
                              className="hover:bg-gray-100 bg-gray-50"
                            >
                              <td className="px-2 text-sm text-gray-500 font-semibold whitespace-nowrap">
                                {moment(t.eventDate).format(
                                  "YYYY-MM-DD hh:mm:ss A"
                                )}
                              </td>

                              <td className="px-2 py-4 align-top max-w-0">
                                <div className="w-full overflow-hidden whitespace-normal break-words break-all">
                                  <p className="font-semibold text-sm text-black-400 break-all whitespace-normal">
                                    {t.eventMessage}
                                  </p>
                                  <p className="font-semibold text-indigo-600 text-sm break-all whitespace-normal">
                                    {t.messageComplement}
                                  </p>
                                </div>
                              </td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>
                  </div>

                  <div
                    className={classNames(
                      "flex flex-col gap-2",
                      (process.env.REACT_APP_PRODUCTION !== "false" ||
                        !allowAddIncidence) &&
                        "hidden"
                    )}
                  >
                    <div>
                      <LinkText
                        text="Agregar incidencia"
                        onClick={() => setShowIncidenceForm(true)}
                      />
                    </div>
                  </div>

                  <hr className={classNames("my-10", !showMap && "hidden")} />

                  <div className={classNames("w-full", !showMap && "hidden")}>
                    <p className="font-medium text-gray-800 text-xl mb-4">
                      Dirección de entrega en Google Maps
                    </p>
                    <div className="w-full h-48 sm:h-80 md:h-[20rem]">
                      <GoogleMap
                        id="map"
                        mapContainerStyle={{
                          height: "100%",
                          width: "100%",
                        }}
                        zoom={17}
                        center={center}
                      >
                        <MarkerF
                          onClick={redirectToGoogleMaps}
                          position={{
                            lat:
                              shipment_?.consigneeAddress?.coordinates.lat ?? 0,
                            lng:
                              shipment_?.consigneeAddress?.coordinates.lng ?? 0,
                          }}
                        />
                      </GoogleMap>
                    </div>
                  </div>
                </AnimatedHeight>
              </div>
            </div>

            {/* Pickup Mode */}
            <AnimatedHeight
              duration={1000}
              active={pickupMode}
              className="flex flex-col"
            >
              <p className="font-light text-xl mb-4">Paquetes a entregar</p>

              <div className="px-2">
                <ShipmentTableCheck
                  fixed={shipment_?.shipmentNumber}
                  shipments={shipments ?? []}
                  selectedShipmentNumbers={selectedShipmentNumbers}
                  setSelectedShipmentNumbers={setSelectedShipmentNumbers}
                />
              </div>

              <hr className="mt-6 mb-2" />
            </AnimatedHeight>

            {/* Buttons */}
            <div className="p-4 border-t">
              <div
                className={classNames(
                  "flex flex-col sm:flex-row sm:justify-between gap-4",
                  hideButtons && "hidden"
                )}
              >
                <div className="flex items-center gap-4 flex-wrap">
                  {isModifiable && (
                    <div hidden={user.user?.roleName === "Consulta Innovus"}>
                      <LinkText
                        text="Anular"
                        onClick={() => setOpenAnnulation(true)}
                      />
                    </div>
                  )}

                  {isModifiable &&
                    shipment_?.paymentMode !== PaymentMode.EXEMPT && (
                      <SecondaryButton
                        onClick={handleModifyClick}
                        className="w-full sm:w-40"
                      >
                        {shipment_?.status === ShipmentStatus.ACTIVE
                          ? "Editar"
                          : "Retomar"}
                      </SecondaryButton>
                    )}
                </div>

                <div className="flex items-center gap-4 flex-wrap justify-end">
                  {(isPrintable || isDestinationPrintable) && (
                    <div className="relative">
                      <PrimaryButton
                        onClick={(e) => setOpenPopover(!openPopover)}
                        className="relative w-full sm:w-40"
                      >
                        Imprimir
                        <ChevronDownIcon
                          className="absolute right-2 top-1/2 transform -translate-y-1/2 h-6 w-6 hidden md:block"
                          aria-hidden="true"
                        />
                      </PrimaryButton>

                      <DropdownMenu
                        open={openPopover}
                        setOpen={setOpenPopover}
                        onSelect={handleDropdownMenuSelect}
                        options={
                          isPrintable ? originOptions : destinationOptions
                        }
                        className="!mb-2 bottom-10 w-full"
                      />
                    </div>
                  )}

                  {isDeliverable && pickupMode && (
                    <div>
                      <SecondaryButton
                        className="w-full sm:w-40"
                        onClick={() => setPickupMode(false)}
                      >
                        Cancelar
                      </SecondaryButton>
                    </div>
                  )}

                  {isDeliverable && (
                    <div className="flex items-center gap-4">
                      <LinkText
                        text="Gestionar servicios adicionales"
                        className={classNames(
                          "text-sm",
                          !itemsAreModifiable && "hidden"
                        )}
                        onClick={() => setOpenOptionalItems(true)}
                      />
                      <PrimaryButton
                        disabled={loading}
                        className="w-full sm:w-40"
                        onClick={() => {
                          if (
                            pickupMode &&
                            !isPaid &&
                            shipment_?.paymentMode !== PaymentMode.CREDIT &&
                            shipment_?.paymentMode !==
                              PaymentMode.BOXOFFICE_CREDIT
                          ) {
                            handlePickup();
                          } else if (
                            (pickupMode &&
                              (isPaid ||
                                shipment_?.paymentMode === PaymentMode.CREDIT ||
                                shipment_?.paymentMode ===
                                  PaymentMode.BOXOFFICE_CREDIT)) ||
                            shipment_?.service === ShipmentService.INTERNAL_MAIL
                          ) {
                            if (
                              !allProofOfPayments &&
                              shipment_?.paymentMode !== PaymentMode.CREDIT &&
                              shipment_?.paymentMode ===
                                PaymentMode.BOXOFFICE_CREDIT &&
                              shipment_?.service ===
                                ShipmentService.INTERNAL_MAIL
                            ) {
                              setOpenPOPWarningModal(true);
                            } else {
                              setOpenPickupModal(true);
                            }
                          } else {
                            setDetails(false);
                            setPickupMode(true);
                          }
                        }}
                      >
                        {!pickupMode
                          ? "Entregar"
                          : isPaid ||
                            shipment_?.paymentMode === PaymentMode.CREDIT ||
                            shipment_?.paymentMode ===
                              PaymentMode.BOXOFFICE_CREDIT ||
                            shipment_?.service === ShipmentService.INTERNAL_MAIL
                          ? "Finalizar"
                          : "Pagar"}
                      </PrimaryButton>
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Delivered */}
        <div
          className={classNames(
            "flex flex-col items-center justify-center flex-1 p-2",
            (!shipment_ || !delivered) && "hidden"
          )}
        >
          <CheckCircleIcon className="text-green-600 w-32 h-32" />
          <p className="mt-2 text-xl text-center font-light text-gray-900">
            {selectedShipmentNumbers.length > 1
              ? "Las guías han sido entregadas."
              : "La guía ha sido entregada."}
          </p>

          <div className="flex w-full justify-center mt-6">
            <PrimaryButton
              className="px-10"
              onClick={() => setOpenModal(false)}
            >
              Aceptar
            </PrimaryButton>
          </div>
        </div>

        <div
          className={classNames(
            "flex flex-col items-center justify-center flex-1 p-8",
            shipment_ && "hidden"
          )}
        >
          <LoadingIcon size="5rem" />
          <p className="mt-2 text-xl text-center font-light text-gray-900">
            Cargando guía...
          </p>
        </div>

        {shipment_?.shipmentNumber &&
          shipment_?.pieces &&
          shipment_.buConsignee &&
          shipment_.consigneeAddress && (
            <NewIncidenceModal
              open={showIncidenceForm}
              setOpen={setShowIncidenceForm}
              shipmentNumber={shipment_.shipmentNumber}
              pieces={shipment_.pieces}
              deliveryType={shipment_.deliveryType}
              businessUnit={shipment_.buConsignee}
              location={shipment_.consigneeAddress}
              handleIncidenceSubmit={handleIncidenceSubmit}
            />
          )}

        <Modal
          openModal={openConfirmDelete}
          setOpenModal={setOpenConfirmDelete}
        >
          <div className="flex flex-col items-center justify-center max-w-[20rem]">
            <div className="flex flex-col items-center justify-center w-full">
              <ExclamationTriangleIcon className="w-32 h-32" />
            </div>

            <p className="mt-2 text-center text-gray-900">
              ¿Está seguro que desea eliminar el envio?{" "}
              {shipment_?.status === ShipmentStatus.ACTIVE && (
                <span>Esta acción necesita la aprobación de casa matriz.</span>
              )}
            </p>

            <div className="mt-4 flex w-full flex-row justify-between gap-4">
              <SecondaryButton
                className="px-4"
                onClick={() => setOpenConfirmDelete(false)}
              >
                Cancelar
              </SecondaryButton>

              <PrimaryButton className="px-4" onClick={() => {}}>
                Aceptar
              </PrimaryButton>
            </div>
          </div>
        </Modal>

        <Modal openModal={openAnulation} setOpenModal={setOpenAnnulation}>
          <div className="flex flex-col items-center justify-center max-w-[20rem]">
            <div className="flex flex-col items-center justify-center w-full">
              <ExclamationTriangleIcon className="w-32 h-32 text-indigo-600" />
            </div>

            <p className="mt-2 text-center text-gray-900">
              ¿Estás seguro que quieres anular la guía{" "}
              <span className="font-bold">{shipment_?.shipmentNumber}</span>?
            </p>

            <div className="mt-4 flex w-full flex-row justify-between gap-4">
              <SecondaryButton
                className="px-4"
                onClick={() => setOpenAnnulation(false)}
              >
                Cancelar
              </SecondaryButton>

              <PrimaryButton className="px-4" onClick={handleAnulation}>
                Aceptar
              </PrimaryButton>
            </div>
          </div>
        </Modal>

        {/* Modal subtitution Shipment by incidence */}
        <Modal openModal={openSubstitutionIncidence} setOpenModal={() => {}}>
          <div className="flex flex-col gap-4 max-w-md mx-auto items-center">
            <div className="flex flex-col items-center">
              <ExclamationTriangleIcon className="text-orange-500 h-28 w-28 mx-auto opacity-90" />
              <h2 className="text-xl font-semibold leading-7 text-gray-700 text-center mt-2">
                {substitutionShipmentIncidence}
              </h2>
            </div>

            <div className="flex flex-col gap-1">
              <p className="text-gray-600 text-center whitespace-pre-line">
                Por favor imprime la etiqueta nueva y pégala encima de la
                original.
              </p>
            </div>

            <div className="flex w-full flex-row gap-3 items-center justify-center mt-4">
              <SecondaryButton
                onClick={() => {
                  setOpenSubstitutionIncidenceModal(false);
                }}
                className="px-4 py-2"
              >
                Imprimir mas tarde
              </SecondaryButton>
              <PrimaryButton
                onClick={async () => {
                  PrintShipmentLabel(
                    newShipmentSubtituteIncidence?.shipmentNumber,
                    newShipmentSubtituteIncidence?.service,
                    newShipmentSubtituteIncidence?.buSource,
                    newShipmentSubtituteIncidence?.userLogin
                  );
                  setOpenSubstitutionIncidenceModal(false);
                }}
                className="px-4 py-2"
              >
                Imprimir
              </PrimaryButton>
            </div>
          </div>
        </Modal>

        <PickupModal
          openModal={openPickupModal}
          setOpenModal={setOpenPickupModal}
          consignee={shipment_?.consignee!}
          onSubmit={() => {
            onReload();
            setDelivered(true);
            navigate(`/documents/${document_?.documentID}`);
          }}
          onDownloadPOD={handleDownloadPOD}
          shipmentNumbers={selectedShipmentNumbers}
          liabilityShipments={liabilityShipments}
          shipments={Array.isArray(shipment) ? shipment : []}
        />
        <OriginModal
          openModal={openLiabilityWaiverModal}
          setOpenModal={setOpenLiabilityWaiverModal}
          shipmentNumbers={[shipment_?.shipmentNumber!]}
          shipments={[shipment_!]}
          shipper={shipment_?.shipper!}
          isModification={true}
          onUpdateLiabilityWaiver={getDigitalLiabilityWaiver}
        />

        {shipment_ && (
          <OptionalShipmentItems
            shipment={shipment_}
            open={openOptionalItems}
            selectedShipmentNumbers={selectedShipmentNumbers}
            setOpen={setOpenOptionalItems}
            onRefresh={() => setRefresh(Math.random())}
          />
        )}

        <DocumentCompatibleShipmentsModal
          openModal={openDocumentCompatibleModal}
          setOpenModal={setOpenDocumentCompatibleModal}
          shipmentNumber={shipment_?.shipmentNumber ?? ""}
          onSelect={handleModifyMultiple}
        />
      </Modal>
      <WarningModal
        openModal={openPOPWarningModal}
        setOpenModal={setOpenPOPWarningModal}
        message="Es necesario agregar todos los comprobantes de los pagos a conciliar para poder finalizar. Cargue los comprobantes requeridos en la vista de pago para continuar."
        onPrimaryButton={() => {
          handlePickup();
        }}
      />
    </>
  );
};

interface ShipmentDetailsClientDataProps {
  client?: AccountInterface;
  businessUnit?: BusinessUnitInterface;
  location?: LocationInterface;
  showLocation?: boolean;
  isShipper?: boolean;
  shipment?: ShipmentInterface;
}
const ShipmentDetailsClientData: FC<ShipmentDetailsClientDataProps> = ({
  client,
  businessUnit,
  location,
  showLocation,
  isShipper = false,
  shipment,
}) => {
  const countries = useAppSelector((state) => state.inmutable.countries);
  const taxIdentificationTypes = useAppSelector(
    (state) => state.inmutable.taxIdentificationTypes
  );

  const identificationType = useMemo(() => {
    return taxIdentificationTypes.find(
      (t) => t.taxIdentificationTypeId === client?.taxIdentificationTypeID
    );
  }, [client, taxIdentificationTypes]);

  const country = useMemo(() => {
    return countries.find(
      (c) => c.id === client?.listAccountPhone[0]?.countryID
    );
  }, [client, countries]);

  const consigneeSplitAddress = useMemo(() => {
    if (location) {
      return location!.address.split(". ");
    } else {
      return "";
    }
  }, [location]);

  return (
    <div className="flex flex-1 flex-col">
      <p className="font-light text-xl">
        {isShipper ? "Remitente" : "Destinatario"}:
      </p>
      <p className="font-medium text-gray-800 ">{client?.accountFullName}</p>
      <p className="text-gray-800 font-light leading-none">
        {identificationType?.abreviationName}
        {client?.identificationNumber}
      </p>
      <p className="text-gray-800 font-light leading-none">
        {country?.countryPhoneAccessCode}{" "}
        {client?.listAccountPhone[0]?.phoneNumber}
      </p>
      <p className="text-gray-800">
        {businessUnit?.code} - {businessUnit?.location.name}
      </p>

      {shipment?.service === ShipmentService.STANDARD_INTERNATIONAL ||
      shipment?.service === ShipmentService.DOCUMENT_INTERNATIONAL ? (
        <>
          <p
            className={classNames(
              "text-gray-800 text-sm",
              !showLocation && "hidden"
            )}
          >
            {`${consigneeSplitAddress[0]} - ${consigneeSplitAddress[1]} (Código postal: ${consigneeSplitAddress[2]})`}
          </p>
          <p
            className={classNames(
              "text-gray-800 text-sm",
              (!location?.reference || !showLocation) && "hidden"
            )}
          >
            {"Dirección: " + location?.reference}
          </p>
        </>
      ) : (
        <>
          <p
            className={classNames(
              "text-gray-800 text-sm",
              !showLocation && "hidden"
            )}
          >
            {`${location?.name} - ${location?.address} ${
              location?.postalCode ? "(" + location?.postalCode + ")" : ""
            }`}
          </p>
          <p
            className={classNames(
              "text-gray-800 text-sm",
              (!location?.reference || !showLocation) && "hidden"
            )}
          >
            {"Punto de ref: " + location?.reference}
          </p>
        </>
      )}
    </div>
  );
};

export default ShipmentDetailsModal;
